
namespace Gamification.Gamification {

    enum AmbitoEnum {
        Indefinito = 0,
        VisualizzaAssetEsperienze = 1,
        VisualizzaProdotti = 2
    }

    @Serenity.Decorators.registerEditor('Gamification.Gamification.ProdottiAssetEsperienze2Editor')
    export class ProdottiAssetEsperienze2Editor extends Serenity.EntityGrid<ProdottiAssetEsperienzeRow, any> {
        protected getColumnsKey() { return ProdottiAssetEsperienzeColumns.columnsKey; }
        protected getDialogType() { return ProdottiAssetEsperienzeDialog; }
        protected getIdProperty() { return ProdottiAssetEsperienzeRow.idProperty; }
        protected getInsertPermission() { return ProdottiAssetEsperienzeRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiAssetEsperienzeRow.localTextPrefix; }
        protected getService() { return ProdottiAssetEsperienzeService.baseUrl; }

        static AmbitoEnum = AmbitoEnum;

        constructor(container: JQuery) {
            super(container);
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return this.idProdotto != null || this.idAssetEsperienza != null;
        }

        protected getColumns() {
            var columns = super.getColumns();

            // Add column
            columns.unshift({
                field: 'Edit Row',
                name: '',
                format: ctx => '<a class="inline-action edit-row" title="Associa sostanze">' +
                    '<i class="fa fa-wrench text-blue"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            // Add column
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            //Add a Button
            buttons.push({
                title: 'Seleziona',
                hint: '',
                cssClass: 'goto-seleziona',
                icon: 'fa-list-ol',
                separator: true,
                onClick: () => { /*Add Function Here */
                    if (this.ambito == AmbitoEnum.VisualizzaAssetEsperienze) {
                        //
                        var assetEsperienzePickerDialog = new AssetEsperienzePickerDialog({
                            hideAssetEsperienze: this.view.getItems().map(x => x.IdProdotto)
                        });
                        //
                        assetEsperienzePickerDialog.onSuccess = (selected) => {
                            // filter already existing products
                            selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdAssetEsperienza == x.IdAssetEsperienza));

                            for (var sel of selected) {
                                var item = <ProdottiAssetEsperienzeRow>{
                                    IdProdotto: this.idProdotto,
                                    IdAssetEsperienza: sel.IdAssetEsperienza
                                    //,FaseTitolo: sel.Titolo
                                };

                                ProdottiAssetEsperienzeService.Create({
                                    Entity: item
                                },
                                    response => {
                                        this.view.addItem({
                                            IdProdottoAssetEsperienza: response.EntityId,
                                            IdProdotto: this.idProdotto,
                                            IdAssetEsperienza: sel.IdAssetEsperienza,
                                            IdAssetEsperienzaNome: sel.Nome
                                        });
                                        //
                                        this.refresh();
                                    },
                                    {
                                        async: false
                                    });
                            }

                            return true;
                        };
                        //
                        assetEsperienzePickerDialog.dialogOpen();
                    }
                    if (this.ambito == AmbitoEnum.VisualizzaProdotti) {

                        var prodottiPickerDialog = new ProdottiPickerDialog({
                            hideProdotti: this.view.getItems().map(x => x.IdAssetEsperienza)
                        });

                        prodottiPickerDialog.onSuccess = (selected) => {
                            selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdProdotto == x.IdProdotto));

                            for (var sel of selected) {
                                var item = <ProdottiAssetEsperienzeRow>{
                                    IdAssetEsperienza: this.idAssetEsperienza,
                                    IdProdotto: sel.IdProdotto,
                                    //IdProdottoNome: sel.Nome
                                };

                                ProdottiAssetEsperienzeService.Create({
                                    Entity: item
                                },
                                    response => {
                                        this.view.addItem({
                                            IdProdottoAssetEsperienza: response.EntityId,
                                            IdAssetEsperienza: this.idAssetEsperienza,
                                            IdProdotto: sel.IdProdotto,
                                            IdProdottoNome: sel.Nome
                                        });
                                        //
                                        this.refresh();
                                    },
                                    {
                                        async: false
                                    });
                            }

                            return true;
                        };

                        prodottiPickerDialog.dialogOpen();
                    }
                }
            });

            //
            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Desideri eliminare il record selezionato?', () => {
                        ProdottiAssetEsperienzeService.Delete({
                            EntityId: item.IdProdottoAssetEsperienza
                        },
                            response => {
                                this.view.deleteItem(item.IdProdottoAssetEsperienza);
                                this.refresh();
                            },
                            { async: false });
                    });
                }

                if (target.hasClass("AssetEsperienza-link")) {
                    e.preventDefault();
                    //
                    new Gamification.AssetEsperienzeDialog().loadByIdAndOpenDialog(item.IdAssetEsperienza);
                }
                else if (target.hasClass("Prodotto-link")) {
                    e.preventDefault();
                    //
                    new Gamification.ProdottiDialog().loadByIdAndOpenDialog(item.IdProdotto);
                }
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        private _ambito: AmbitoEnum = AmbitoEnum.Indefinito;
        private _idProdotto: number;
        private _idAssetEsperienza: number;

        // +++++++++++++++++++++++++++++++++++++++++++
        get ambito() {
            return this._ambito;
        }

        set ambito(value: AmbitoEnum) {
            if (this._ambito != value) {
                this._ambito = value;

                if (this._ambito == AmbitoEnum.VisualizzaAssetEsperienze) {
                    var columns = this.slickGrid.getColumns();

                    //var nIndice = Q.indexOf(columns, x => x.field == ProdottiAssetEsperienzeRow.Fields.IdAssetEsperienzaNome);
                    //columns.splice(nIndice, 1);

                    //nIndice = Q.indexOf(columns, x => x.field == ProdottiAssetEsperienzeRow.Fields.UnitaNome);
                    //columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }

                if (this._ambito == AmbitoEnum.VisualizzaProdotti) {
                    var columns = this.slickGrid.getColumns();

                    //var nIndice = Q.indexOf(columns, x => x.field == ProdottiAssetEsperienzeRow.Fields.IdProdottoTitolo);
                    //columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idAssetEsperienza() {
            return this._idAssetEsperienza;
        }

        set idAssetEsperienza(value: number) {
            if (this._idAssetEsperienza != value) {
                this._idAssetEsperienza = value;
                this.setEquality(ProdottiAssetEsperienzeRow.Fields.IdAssetEsperienza, value);
                this.refresh();
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idProdotto() {
            return this._idProdotto;
        }

        set idProdotto(value: number) {
            if (this._idProdotto != value) {
                this._idProdotto = value;
                this.setEquality(ProdottiAssetEsperienzeRow.Fields.IdProdotto, value);
                this.refresh();
            }
        }
    }
}